import { Box } from '@factorialco/deprecated-design-system'
import { AtsCandidateTagsFragment } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { CandidateTag } from './CandidateTag'
import { type CandidateSource, CandidateTagsSelector } from './CandidateTagsSelector'

interface Props extends CandidateSource {
  candidate: AtsCandidateTagsFragment
}

export const CandidateTags = ({ candidate, source }: Props) => {
  const renderCandidateTags = orderBy(candidate.tags, ['name']).map((tag) => (
    <CandidateTag key={tag.id} candidateId={candidate.id} tag={tag} />
  ))

  return (
    <Box gap="s12" alignItems="flexStart">
      {renderCandidateTags.length > 0 && (
        <Box flexDirection="row" gap="s12" alignItems="center" flexWrap="wrap">
          {renderCandidateTags}
        </Box>
      )}
      <CandidateTagsSelector candidate={candidate} source={source} />
    </Box>
  )
}
